export default __webpack_public_path__ + "static/media/l-1.f5203fe8.png";